/**
 * Typography Design Tokens
 *
 * Font families, sizes, weights, and complete typography scale.
 * Includes all variants used across the design system.
 */

// Font families
export const fontFamilies = {
  inter: 'Inter, sans-serif',
  poppins: 'Poppins, sans-serif',
  default: 'Inter, sans-serif', // Base font family
} as const

// Font weights
export const fontWeights = {
  normal: '400',
  medium: '500',
  semibold: '600',
  bold: '700',
  extrabold: '800',
  black: '900',
} as const

// Font sizes (in px)
export const fontSizes = {
  8: '8px',
  10: '10px',
  12: '12px',
  14: '14px',
  16: '16px',
  20: '20px',
  24: '24px',
  32: '32px',
  40: '40px',
  48: '48px',
  72: '72px',
} as const

// Line heights (as percentages or unitless)
export const lineHeights = {
  100: '100%',
  116: '116.7%',
  120: '120%',
  123: '123.5%',
  128: '128.571%',
  140: '140%',
  143: '143%',
  150: '150%',
  157: '157%',
  166: '166%',
  171: '171%',
  250: '250%',
} as const

// Letter spacing (in px)
export const letterSpacing = {
  0: '0px',
  0.1: '0.1px',
  0.14: '0.14px',
  0.15: '0.15px',
  0.17: '0.17px',
  0.2: '0.2px',
  0.25: '0.25px',
  0.4: '0.4px',
  1: '1px',
  [-1.5]: '-1.5px',
  [-0.5]: '-0.5px',
} as const

// Consolidated export
export const typography = {
  fontFamily: fontFamilies.default,
  fontFamilies,
  fontWeights,
  fontSizes,
  lineHeights,
  letterSpacing,
} as const
